<template>
    <div class="agri-footer" ref="footerRef">
        <footer class="footer">
            <div class="footer-links" :style="{ gridTemplateColumns: `repeat(${(platInfo.gzh||platInfo.tradeImg) ? 5 : 4}, 1fr)` }">
                <div class="footer-column" v-for="(footerJ, footerIndex) in footerData" :key="footerIndex">
                    <h4 class="footer-title">{{ footerJ.name }}</h4>
                    <div class="footer-links-list" :class="[footerJ.value == 'rmfw' ? `rmfw` : '']">
                        <a v-for="(item, i) in footerJ.list" :key="i" class="footer-link"
                            :class="[(item[footerJ.hrefLabel]&&footerJ.value!=='hzlx')||footerJ.value=='gywm'?`wui-hover-color-${themeColor}`:'cursorAuto']"
                            @click="toHref(item[footerJ.hrefLabel], '_blank',item,footerJ.value)" :title="isTextOverflow(item[footerJ.label]) ? item[footerJ.label] : null">
                            {{ item[footerJ.label] }}
                        </a>
                    </div>
                </div>
                <div class="footer-column" v-if="platInfo.gzh||platInfo.tradeImg">
                    <h4 class="footer-title">关注全球商通中心</h4>
                    <div class="qr-code-list">
                        <div class="qr-code" v-if="platInfo.gzh">
                            <div class="qr-container">
                                <div class="qr-image">
                                    <img :src="commenUrl+platInfo.gzh" alt="">
                                </div>
                            </div>
                            <div class="qr-text">微信扫码关注</div>
                        </div>
                        <div class="qr-code" v-if="platInfo.tradeImg">
                            <div class="qr-container">
                                <div class="qr-image">
                                    <img :src="commenUrl+platInfo.tradeImg" alt="">
                                </div>
                            </div>
                            <div class="qr-text">微信小程序</div>
                        </div>
                    </div>
                </div>

            </div>

            <footerZz :themeColor="themeColor" :platInfo="platInfo"/>
        </footer>
    </div>
</template>
<script setup>
import { ref, defineProps, defineEmits, onMounted, onUnmounted, watch, nextTick, getCurrentInstance } from 'vue'
import footerZz from "./footerZz.vue"
const props = defineProps({
    themeColor: {
        type: String,
        default: 'blue'
    },
    platInfo: {
        type: Object,
        default: {}
    }
})
const { proxy } = getCurrentInstance();
const gywmShow = ref(false)
const footerData = ref([
    {
        "name": "关于我们",
        "value": "gywm",
        "label": "linkName",
        "hrefLabel": "linkAddress",
        "list": [
        ]
    },
    {
        "name": "热门服务",
        "value": "rmfw",
        "label": "linkName",
        "hrefLabel": "linkAddress",
        "list": [
        ]
    },
    {
        "name": "友情链接",
        "value": "yqlj",
        "label": "linkName",
        "hrefLabel": "linkAddress",
        "list": [
        ]
    },
    {
        "name": "合作联系",
        "value": "hzlx",
        "label": "linkName",
        "hrefLabel": "linkAddress",
        "list": [
        ]
    }
]);
const gywmData = ref([
    {
        "url": "wxewm",
        "name": "微信二维码"
    },
    {
        "url": "dpxcx",
        "name": "店铺小程序"
    }
])

const footerRef = ref(null);
const footerHeight = ref(0);
const getLink = (linkType,index) => {
    // 获取0:友情链接1:热门服务2:合作联系3:合作联盟
    proxy.$request({
        url: "PROTAL_N_INDUSTRYFRIENDLY_FINDLIST",
        method: "post",
        data: { "isShow": "0", "portalType": proxy.getConfig().portalType,linkType:linkType }
    }).then((res) => {
        if (res.data.code == "000") {
            footerData.value[index].list = res.data.result;
        }
    }).catch((err) => {
        console.log(err)
    });
}
const getAboutus = () => {
    // 获取关于我们
    proxy.$request({
        url: "PROTAL_N_INDUSTRYMODULE_FINDPAGELIST",
        method: "post",
        data: { "portalType": proxy.getConfig().portalType, "moduleCategory": "1" }
    }).then((res) => {
        if (res.data.code == "000") {
            footerData.value[0].list = res.data.result.list;
        }
    }).catch((err) => {
        console.log(err)
    });
}

onMounted(async () => {
    await nextTick();
    if (footerRef.value) {
        footerHeight.value = footerRef.value.offsetHeight
    }

    window.addEventListener('resize', () => {
        if (footerRef.value) {
            footerHeight.value = footerRef.value.offsetHeight
        }
    });

    getLink(0,2)
    getLink(1,1)
    getLink(2,3)
    getLink(4,0)
    // getAboutus()
});

onUnmounted(() => {
    window.removeEventListener('resize', () => { });
});

const emits = defineEmits(['heightChange']);
watch(footerHeight, (newVal, oldVal) => {
    emits('heightChange', newVal);
});
// 跳转
// 判断是否为完整URL
const isFullUrl = (url) => {
    return /^https?:\/\//.test(url);
};

// 执行跳转
const toHref = (url, type, item,v) => {
    if (!url||v=='hzlx') {
        return;
    }
    let query = {}
    console.log(url)
    if(url=='aboutUs'){
        if(item.moduleType=='9'){
            url = item.moduleCont
        }else{
            if (type === '_blank') {
                url += '?id=' + item.id
            }else{
                query.id=item.id
            }
            
        }
    }
    
    if (type === '_blank') {
        // 新标签页打开
        proxy.tool.openWindow(url);
    } else if (isFullUrl(url)) {
        // 完整URL，使用页面跳转
        window.location.href = url;
    } else {
        // 相对路径，使用路由跳转
        router.push(url,query);
    }
};
const isTextOverflow = (text) => {
  // 创建一个临时元素用于检测文本宽度
  const tempElement = document.createElement('span');
  tempElement.style.visibility = 'hidden';
  tempElement.style.whiteSpace = 'nowrap';
  tempElement.style.position = 'absolute';
  tempElement.style.fontSize = '14px'; // 与 .footer-link 的字体大小一致
  tempElement.textContent = text;
  document.body.appendChild(tempElement);

  // 获取文本的实际宽度
  const textWidth = tempElement.offsetWidth;
  document.body.removeChild(tempElement);

  // 检查是否超出容器宽度（假设容器宽度为 100%）
  return textWidth > 267; // 可根据实际容器宽度调整
};
</script>
<style scoped lang="less">
/* 页脚样式 */
.agri-footer {
    background-color: #F7F7F7;
    width: 100%;
    min-width: 1240px;

    .footer {
        padding: 40px 0 30px;
        min-height: 355px;
        width: 1200px;
        margin: 0 auto;

        .footer-links {
            padding-bottom: 15px;
            // border-bottom: 1px solid #ddd;
            display: grid;
            box-sizing: border-box;
            grid-auto-columns: auto;
            flex: 1 1;
            grid-gap: 0 20px;
        }

        .footer-title {
            font-size: 16px;
            font-weight: 600;
            color: #191919;
            border-bottom: 1px solid #D8D8D8;
            padding-bottom: 13px;
        }

        .footer-column {
            display: flex;
            flex-direction: column;

            .footer-links-list {
                display: flex;
                flex-direction: column;

                .footer-link {
                    font-size: 14px;
                    color: #191919;
                    text-decoration: none;
                    transition: color 0.3s;
                    cursor: pointer;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    line-height: 34px;
                }
                .cursorAuto{
                    cursor: auto;
                }
            }

            .rmfw {
                display: grid;
                grid-template-columns: 1fr 1fr;

                .footer-link {
                    min-width: 37%;
                }
            }
        }



        .footer-content {
            display: flex;
            justify-content: space-between;
            padding: 30px 0;
        }

        .contact-info {
            display: flex;
            flex-direction: column;
        }

        .contact-item {
            font-size: 14px;
            color: #191919;
            margin-bottom: 10px;
        }

        .qr-code-list {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-auto-columns: auto;
            flex: 1 1;
            grid-gap: 0 20px;

            .qr-code {
                display: flex;
                flex-direction: column;
                margin-top: 22px;

                .qr-container {
                    background-color: #fff;
                    width: 114px;
                    height: 114px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 10px;
                }

                .qr-image {
                    width: 114px;
                    height: 114px;
                    background: linear-gradient(135deg, #ff9999, #ff3333);
                    img{
                        width: 114px;
                        height: 114px;
                    }
                }

                .qr-text {
                    font-size: 12px;
                    color: #191919;
                    text-align: center;
                    width: 114px;
                }
            }
        }




        .copyright {
            font-size: 13px;
            color: #191919;
            line-height: 24px;
            // text-align: center;
            // padding-top: 20px;
            // border-top: 1px solid #eee;
        }
    }
}



@media (min-width: 1680px) {
    .agri-footer {
        .footer {
            width: 1600px;

            .footer-links {
                grid-gap: 0 66px;
            }
        }
    }


}
</style>
